import { fromTemplate } from '../../utils/dom.js';
import './header.css';

export class Header {
  render() {
    const template = `
      <header class="sl-header" data-testid="site-header">
        <div class="container sl-header__bar">
          <a class="sl-header__brand" href="#top" data-testid="brand-link">
            <span class="sl-header__logo" aria-hidden="true">SL</span>
            <span class="sl-header__name">Striking Labs</span>
          </a>
          <nav class="sl-header__nav" aria-label="Primary">
            <ul>
              <li><a href="#services" data-testid="nav-services">Services</a></li>
              <li><a href="#ai-lab"   data-testid="nav-ai-lab">AI Lab</a></li>
              <li><a href="#about"    data-testid="nav-about">About</a></li>
              <li><a href="#contact"  data-testid="nav-contact">Contact</a></li>
            </ul>
          </nav>
          <button class="sl-header__menu" type="button"
                  aria-label="Toggle navigation"
                  aria-expanded="false"
                  data-testid="nav-toggle">
            <span></span><span></span><span></span>
          </button>
        </div>
      </header>
    `;
    const el = fromTemplate(template);
    const btn = el.querySelector('.sl-header__menu');
    const nav = el.querySelector('.sl-header__nav');
    btn.addEventListener('click', () => {
      const open = el.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
      nav.classList.toggle('is-open', open);
    });
    nav.addEventListener('click', (e) => {
      if (e.target instanceof HTMLAnchorElement) {
        el.classList.remove('is-open');
        nav.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
    return el;
  }
}
